import React from "react";
import Header from "./components/Header";
import OSIVisualization from "./components/OSIVisualization";
import "./App.css";

const App = () => {
  return (
    <div className="app">
      <Header />
      <OSIVisualization />
    </div>
  );
};

export default App;
